<template>
    <div class="acountStatus"> 
        <div class="mainTitle text-center my-4">
            
            <message-component :message="response_msg" :messageType="msg_type"></message-component>
        </div>
        <div class="whiteBG radius pt-3"> 
            <div class="d-flex flex-wrap tabcenter justify-content-between border-bottom pb-3 px-3 mb-2 align-items-center"> 
                <div><h2 class="mb-0">{{$t('dl_depositList')}}</h2></div>
                <div class="requestbtn commanfilter d-flex align-items-center">
                   <filter-component></filter-component>  
                </div>   
            </div>
            <div class="inMiddle-area table-responsive ">
                <table class="table pmmTable">
                    <thead>
                        <tr>
							<th>{{$t('dl_transId')}}</th>
							<th>{{$t('dep_acc_fund_accountId')}}</th>
                            <th>{{$t('req_amount')}}</th>
							<th>{{$t('dash_currency')}}</th>
                            <th>{{$t('dl_status')}}</th>
							<th>{{$t('dl_Method')}}</th>
							<th>{{$t('dl_type')}}</th>
							<th>{{$t('dl_created')}}</th>
							<th>{{$t('dl_action')}}</th>
                        </tr>
                    </thead>
                    <tbody v-if="(!pageLoader && depositList != '' && depositList.totalRecords > 0)">
                        <tr v-for="list in depositList.records" >
							<td>
                                <span v-if="list.deposit_method != '' && list.deposit_method != null && parseInt(list.deposit_method) == 18">{{list.internal_tx_id}} </span>
                                <span v-else>{{list.transaction_id}} </span>
                            </td>
                            <td><p v-html="(list.wallet_no != '' && list.wallet_no != null && list.wallet_no != undefined)? list.wallet_no  : list.account_id"></p> </td>
                            <td>{{parseFloat(list.amount).toFixed(2)}}</td>
                            <td><img :src="'../../../../static/fxView/images/'+$env_var.currency[list.currency.toUpperCase()]" class="data_currency rounded-circle"></td>
                            <td>
								<span v-if="list.payment_status == '' || list.payment_status == null">-</span>
								<span class="badge badge-pill badge-warning" v-if="parseInt(list.payment_status) == -1 || parseInt(list.payment_status) == 0">{{$env_var.paymentStatus[list.payment_status]}}</span>
								<span class="badge badge-pill badge-danger" v-if="parseInt(list.payment_status) == 2 || parseInt(list.payment_status) == 3 || parseInt(list.payment_status) == 4">{{$env_var.paymentStatus[list.payment_status]}}</span>
								<span class="badge badge-pill badge-success" v-if="parseInt(list.payment_status) == 1">{{$env_var.paymentStatus[list.payment_status]}}</span>
                            </td>
							<td v-html="(list.deposit_method != '' && list.deposit_method != null)
                                ?
                                (parseInt(list.deposit_method) == 28 || parseInt(list.deposit_method) == 29) ? 'Bank' : $env_var.depositMethod[list.deposit_method]
                                :
                                '-'">
                            </td>
							<td v-html="(list.deposit_type != '' && list.deposit_type != null)?$env_var.depositType[list.deposit_type] : '-'"></td>
							<td>{{list.created | moment("DD MMMM YYYY")}}</td>
							<td>
                                <span v-if="list.deposit_method != '' && list.deposit_method != null && parseInt(list.deposit_method) == 18">-</span>
								<router-link :to="{name: 'fxView.depositTransaction' , query: { 'id': list.transaction_id}}"  title="View" data-placement="top"  data-toggle="tooltip" v-else>
                                    <feather type="eye"></feather>
                                </router-link>
							</td>
                        </tr>
                    </tbody>
                    
                    <loader-component :pageloader_value="pageLoader" :type="'table'" :colspan="col_span" :list="depositList" v-else-if="!pageLoader"></loader-component>
                </table>
            </div>
            <div class="border-top ">
                <pagination :getList="depositList" :limit="pageLimit" v-if="depositList.totalRecords > 15"></pagination>
            </div>
        </div>
        
    </div> 
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    import moment from 'moment'
    export default {
        name: 'Dashboard',
        mixins: [fxViewMixins],
        data() {
            return {
                //===========prop in loader component=======
                col_span : 9,
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                loaderFuncRun : '1',
                //==========================================
                pageLimit : '15',
                search : '',
                page : '1', 
                pagename : 'deposit-list'
            }
        },
        methods:{
            listing(){
                if(this.search != ''){
                    this.loaderFuncRun = '0'
                }
                let inputJson = {
                    'globalParams' : {
                        filter: {},
                        sort: [],
                        search: this.search,
                        page: this.page,
                        perPage: parseInt(this.pageLimit),
                    } ,'localParams' : {'parameter' : this , 'loaderFuncRun' : this.loaderFuncRun}
                }

                this._runGetDepositList(inputJson)
            }
        },
        created(){
            if(this.$store.getters[Const.GET_DEPOSIT_LIST] != ''){
                this.loaderFuncRun = '0'
            }
            this.listing()
            // if(parseInt(list.payment_status) == 1) {
            //     let
            // }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/deposit/deposit_listing.vue